import React, { useState } from 'react';
import { Form, Input, InputNumber, Button } from 'antd';
import { CartItem } from '~/types/Cart';
import i18n from '~/i18n';

const CustomItemPanel = ({
  initialValues,
  onSubmit,
}: {
  initialValues?: CartItem;
  onSubmit: (item: CartItem) => void;
}) => {
  const onFinish = ({
    name,
    price,
    notes,
  }: {
    name: string;
    price: number;
    notes: string;
  }) => {
    onSubmit({
      menuId: '',
      quantity: 1,
      addOns: [],
      notes,
      custom: true,
      name,
      totalPrice: price,
    });
  };

  return (
    <div>
      <Form
        onFinish={onFinish}
        initialValues={initialValues ?? { name: 'Custom' }}
        name="custom-item"
      >
        <Form.Item
          label="Nama"
          name="name"
          rules={[{ required: true, message: 'Nama wajib diisi' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Harga"
          name="price"
          rules={[{ required: true, message: 'Harga wajib diisi' }]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label={i18n.t('menu_panel_notes')} name="notes">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" size="large" block>
            {i18n.t('menu_panel_submit')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CustomItemPanel;
